import { reduxForm } from 'redux-form/immutable'
import { Map, Set } from 'immutable'
import { connect } from 'react-redux'

import { getMentionUsersList } from 'store/entities/users/selectors'
import { setStory } from 'store/entities/activity/actions'
import { updateStoryApiRequest } from 'store/entities/feed/actions'
import { getJoinedUserFullName } from 'helpers/getUserUIData'
import MicroActivityBlockStoryForm from './MicroActivityBlockStoryForm'

import { syncValidate as validate } from 'app/validators/stories/create'
import { getActivityId, getActivityUserActivityId, getEditingStory, getStory } from 'store/entities/activity/selectors'
import { getIdentityActivitiesHistoryItems } from 'store/entities/identity/selectors'

const mapStateToProps = (state: any, ownProps: any) => {
  const editStory = getEditingStory(state)
  const activityHistory = getIdentityActivitiesHistoryItems(state)
  let story = ownProps.story || getStory(state)
  let activityId = ownProps.activityId || getActivityId(state)
  let userActivityId = ownProps.userActivityId || getActivityUserActivityId(state)

  if (story.id !== editStory.id) {
    for (const act of activityHistory) {
      if (act.userActivityId === editStory.userActivityId) {
        activityId = editStory.id
        userActivityId = editStory.userActivityId
        story = act.story
          ? act.story
          : {
              id: null,
              story: '',
            }

        break
      } else {
        story = {
          id: null,
          story: '',
        }
      }
    }
  }

  return {
    mentionUsers: getMentionUsersList(state),
    activityId,
    userActivityId,
    initialValues: Map({
      storyId: story.id,
      story: story.story,
    }),
  }
}

const formProps = {
  validate,
  onSubmit: (values: any, dispatch: any, { mentionUsers, activityId, userActivityId, initialValues }: any) => {
    const valuesStoryForm = values.toJS()
    mentionUsers = Set(mentionUsers).toJS()
    let story = valuesStoryForm.story
    const mentions = mentionUsers
      .filter(user => {
        const { firstName, lastName, email } = user
        const key = `@${getJoinedUserFullName(firstName, lastName, email)}`
        // Escaping characters that are used in regular expressions
        const escapedKey = key.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
        const reqExp = new RegExp(`(${escapedKey})([\\W]|$)`, 'g')
        if (reqExp.test(story)) {
          story = story.replace(reqExp, `<b>${key}</b> `)
          return true
        }
        return false
      })
      .map(user => user.id)

    if (initialValues.get('story')) {
      dispatch(
        updateStoryApiRequest({
          activityId,
          userActivityId,
          story,
          mentions,
          storyId: valuesStoryForm.id,
          ...valuesStoryForm,
        })
      )
    } else {
      dispatch(setStory({ activityId, userActivityId, story, mentions, ...valuesStoryForm }))
    }
  },
}

export default connect(mapStateToProps)(reduxForm(formProps)(MicroActivityBlockStoryForm)) as any
